var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GD001",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    gradientUnits: "userSpaceOnUse",
    x1: 192,
    x2: 192,
    y1: -13.488,
    y2: 416.541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc5c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#f35e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#d9659b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#b070bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a82fb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 256,
    x2: 256,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 324,
    x2: 324,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 176,
    x2: 176,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    x1: 184,
    x2: 184,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-8",
    x1: 112,
    x2: 112,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-9",
    x1: 456,
    x2: 456,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-10",
    x1: 368,
    x2: 368,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-11",
    x1: 464,
    x2: 464,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-12",
    x1: 424,
    x2: 424,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: -13.488,
    y2: 416.541
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m152.4 132.247c-11.926 11.927-19.164 27.192-20.379 42.984-1.25 16.256 3.978 31.125 14.722 41.87 9.7 9.7 22.76 14.9 37.17 14.9q2.327 0 4.7-.182c15.793-1.215 31.058-8.452 42.985-20.379s19.164-27.192 20.379-42.984c1.25-16.256-3.978-31.125-14.722-41.869-21.834-21.832-59.899-19.293-84.855 5.66zm83.621 34.984c-.921 11.988-6.511 23.67-15.739 32.9-9.227 9.227-20.911 14.817-32.9 15.739-11.523.883-21.939-2.695-29.327-10.083s-10.969-17.8-10.082-29.327c.921-11.987 6.511-23.67 15.739-32.9 10.472-10.473 23.821-15.879 36.284-15.879 9.81 0 19.072 3.352 25.941 10.221 7.393 7.39 10.973 17.806 10.086 29.329z",
    fill: "url(#New_Gradient_Swatch_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m184 163.846h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m488.944 198.075a8 8 0 0 0 -7.765-6.075h-42.241l-2.285-16h27.347v-16h-29.633l-2.448-17.132a7.99 7.99 0 0 0 -3.482-5.524l-14.015-9.344h25.578v-16h-49.578l-9.985-6.656a8 8 0 0 0 -4.437-1.344h-32v-16h40v-16h-40v-33.835a8 8 0 0 0 -5.242-7.51 240.523 240.523 0 0 0 -290.704 105.345h-.054v.093a236.951 236.951 0 0 0 -23.416 55.907h-.584v2.221a241.358 241.358 0 0 0 -8 61.779 238.58 238.58 0 0 0 32 119.907v.093h.054a241.36 241.36 0 0 0 38.24 49.7 240.09 240.09 0 0 0 285.574 40.506 8 8 0 0 0 4.132-7v-19.206h24v-16h-24v-16h72v-16h-60.687l16-16h36.687a8 8 0 0 0 8-8v-16h32v-16h-32v-17.351l36.479-6.784a8 8 0 0 0 6.365-6.218 241.434 241.434 0 0 0 -1.9-107.572zm-352.944 105.925v16h176v40h-254.5a221.144 221.144 0 0 1 -16.26-40h46.76v-16h-50.862a225.353 225.353 0 0 1 -4.982-40h159.844v40zm340.222-6.874-37.685 7.009a8 8 0 0 0 -6.537 7.865v48h-32a8 8 0 0 0 -5.657 2.343l-32 32a8 8 0 0 0 -2.343 5.657v54.431a224.175 224.175 0 0 1 -242.6-22.431h42.6v-16h-60.744c-.548-.538-1.1-1.065-1.648-1.608a225.909 225.909 0 0 1 -30.841-38.392h181.233v40h-40v16h136v-16h-80v-40h96v-16h-32v-40h88v-16h-208v-40h224v-16h-72v-40h48v-16h-144v16h80v40h-311.844a225.353 225.353 0 0 1 4.982-40h82.862v-16h-78.76a221.144 221.144 0 0 1 16.26-40h62.5v-16h-53.233a225.909 225.909 0 0 1 30.841-38.392c.544-.543 1.1-1.07 1.648-1.608h52.744v-16h-34.6a224.437 224.437 0 0 1 210.6-36.178v68.178a8 8 0 0 0 8 8h37.578l43.008 28.672 7.5 52.46a8 8 0 0 0 7.914 6.868h42.83a225.557 225.557 0 0 1 1.392 89.126z",
    fill: "url(#New_Gradient_Swatch_2-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m272 136h104v16h-104z",
    fill: "url(#New_Gradient_Swatch_2-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m168 80h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m200 80h112v16h-112z",
    fill: "url(#New_Gradient_Swatch_2-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m176 416h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m104 304h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m448 248h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m360 40h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m456 128h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m416 424h16v16h-16z",
    fill: "url(#New_Gradient_Swatch_2-12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceStation);
export default __webpack_public_path__ + "static/media/space-station.7a027c6ec10ba7b5d8c880df5f4e65ea.svg";
export { ForwardRef as ReactComponent };